import { initGlobalDateProps } from "./GlobalDateProps";

let GlobalCurrReportParameters = [];
export const setGlobalCurrReportParameters = (newGlobalCurrReportParameters) => {
    initGlobalDateProps();
    GlobalCurrReportParameters = newGlobalCurrReportParameters;
    console.log(["GlobalCurrReportParameters", GlobalCurrReportParameters]);
}

const data2number = (data) => {
    let res = data ? data.value : data;
    let num = +res;
    return num;
}
const tryConvertDataValueToLocaleNumberPrecision = (data, precision) => {
    let res = data ? data.value : data;
    try {
        let num = +res;
        if (!isNaN(num)) {
            res = num.toLocaleString("ru-RU",
                {
                    maximumFractionDigits: precision,
                    minimumFractionDigits: precision,
                });
        }
    }
    catch (e) { }
    return res;
}
const tryConvertDataValueToLocaleNumberPrecision0 = (data) => {
    return tryConvertDataValueToLocaleNumberPrecision(data, 0);
}
const tryConvertDataValueToLocaleNumberPrecision2 = (data) => {
    return tryConvertDataValueToLocaleNumberPrecision(data, 2);
}
const tryConvertDataValueToLocaleNumberPrecision3 = (data) => {
    return tryConvertDataValueToLocaleNumberPrecision(data, 3);
}

const tryConvertValueToLocaleNumberPrecision = (value, precision) => {
    return tryConvertDataValueToLocaleNumberPrecision({ value: value }, precision);
}

const convertDateToLocaleString = (date, options) => {
    return date.toLocaleString('ru-RU', options);
}

//var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
const tryConvertWeekDayToLocaleWeekDay = (data, options) => {
    const weekday = data2number(data);
    if (isNaN(weekday)) return;
    let date = new Date(2023, 0, 1 + weekday, 0, 0, 0, 0);
    return convertDateToLocaleString(date, options);
}
const tryConvertWeekDayToLocaleWeekDayLong = (data) => {
    return tryConvertWeekDayToLocaleWeekDay(data, { weekday: 'long' });
}
const tryConvertWeekDayToLocaleWeekDayShort = (data) => {
    return tryConvertWeekDayToLocaleWeekDay(data, { weekday: 'short' });
}

const tryConvertMonthToLocaleMonthName = (data, options) => {
    const month = data2number(data);
    if (isNaN(month)) return;
    let date = new Date(2023, 0 + month, 1, 0, 0, 0, 0);
    return convertDateToLocaleString(date, options);
}
const tryConvertMonthToLocaleMonthNameLong = (data) => {
    return tryConvertMonthToLocaleMonthName(data, { month: 'long' });
}
const tryConvertMonthToLocaleMonthNameShort = (data) => {
    return tryConvertMonthToLocaleMonthName(data, { month: 'short' });
}

const makeCounter = () => {
    let value = 0;
    return (delta) => {
        value = value + delta;
        return value;
    }
}

const calculateCustomSummaryAverageCheck = (options, fieldSum, fieldCount) => {
    //    if (options.name === 'AvgCheckSum') 
    const optionSumName = "userDataTotalSumCounter" + options.name;
    const optionCountName = "userDataTotalCountCounter" + options.name;
    {
        if (options.summaryProcess === 'start') {
            options.component.option(optionSumName, makeCounter());
            options.component.option(optionCountName, makeCounter());
            options.component.option(optionSumName)(0);
            options.component.option(optionCountName)(0);
        }
        else if (options.summaryProcess === 'calculate') {
            options.component.option(optionSumName)(options.value[fieldSum]);
            options.component.option(optionCountName)(options.value[fieldCount]);
        }

        else if (options.summaryProcess === 'finalize') {
            let totalResult = options.component.option(optionSumName)(0);
            let totalTarget = options.component.option(optionCountName)(0);

            if (totalTarget == 0) {
                return;
            }
            options.totalValue = (totalResult / totalTarget);
        }
    }
}

const onOpenedDxDateBoxWithTodayOnly = (e) =>{
    if (e.component.option("type") != "date") {
        return;
    }
    e.component._popup.option('toolbarItems[0]',
        {
            widget: 'dxButton',
            toolbar: 'bottom',
            location: 'before',
            options: {
                text: 'Сегодня',//'Today'
                onClick: function (x) {
                    e.component.option('value', Date.todayLocal());
                    e.component.close();
                }
            }
        });
}



const _global = (window /* browser */ || global /* node */) as any
//_global.s = s;
//_global.calculateCustomSummaryAverageCheck = calculateCustomSummaryAverageCheck;

window["calculateCustomSummaryAverageCheck"] = calculateCustomSummaryAverageCheck;
window["onOpenedDxDateBoxWithTodayOnly"] = onOpenedDxDateBoxWithTodayOnly;


export const getCurrReportParamValue = (paramName, attrName, defaultValue) => {
    let res = GlobalCurrReportParameters.find(item => paramName && ((item.name || "").toUpperCase() == (paramName || "").toUpperCase()));
    if (!res) {
        return defaultValue;
    }
    res = res[attrName];
    if (!res) {
        return defaultValue;
    }
    return res;
}

window["getCurrReportParamValue"] = getCurrReportParamValue;

export const GlobalProps = {
    tryConvertDataValueToLocaleNumberPrecision0: tryConvertDataValueToLocaleNumberPrecision0,
    tryConvertDataValueToLocaleNumberPrecision2: tryConvertDataValueToLocaleNumberPrecision2,
    tryConvertDataValueToLocaleNumberPrecision3: tryConvertDataValueToLocaleNumberPrecision3,
    tryConvertWeekDayToLocaleWeekDayLong: tryConvertWeekDayToLocaleWeekDayLong,
    tryConvertWeekDayToLocaleWeekDayShort: tryConvertWeekDayToLocaleWeekDayShort,
    tryConvertMonthToLocaleMonthNameLong: tryConvertMonthToLocaleMonthNameLong,
    tryConvertMonthToLocaleMonthNameShort: tryConvertMonthToLocaleMonthNameShort,
    tryConvertValueToLocaleNumberPrecision: tryConvertValueToLocaleNumberPrecision,
//    getCurrReportParamValue: getCurrReportParamValue,

};

